// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RoundedButtonGroup {
  --height: 25px;
  position: relative;
  z-index: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.RoundedButtonGroup .badgeNumber {
  font-size: 10px;
  font-weight: bold;
  display: block;
  width: 25px;
}

.RoundedButtonGroup .badgeNumber-container {
  background-color: var(--ui-border-color-dark);
  width: 21px;
  height: 21px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border-radius: 50%;
  font-size: 12px;
  font-weight: bold;
  bottom: 10px;
  left: 5px;
  color: white;
  position: absolute;
}

.roundedButtonWrapper {
  width: 100%;
  cursor: pointer;
  display: inline-block;
  float: left;
  margin-left: -2px;
  text-decoration: none;
  text-align: center;
}

.roundedButtonWrapper.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.RoundedButtonGroup .roundedButtonWrapper .roundedButton {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background-color: var(--ui-gray-dark);
  border: 2px solid var(--ui-border-color-dark);
  color: var(--text-secondary-color);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 15px;
  font-weight: 500;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  height: var(--height);
  line-height: var(--height);
  padding: 0 16px;
  position: relative;
  text-transform: uppercase;
  -webkit-transition: var(--sidebar-transition);
  transition: var(--sidebar-transition);
  z-index: 1;
}

.roundedButtonWrapper
  .roundedButton
  svg
  .roundedButtonWrapper
  .roundedButton
  span {
  margin: 0 2px;
}

.roundedButtonWrapper .roundedButton i {
  line-height: 15px;
  font-size: 15px;
}

.roundedButtonWrapper .bottomLabel {
  padding: 0 10px 0 10px;
}

.bottomLabel {
  color: var(--text-secondary-color);
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  margin-top: 10px;
  margin-bottom: 2px;
}

.roundedButtonWrapper:first-child {
  margin-left: 0;
}

.RoundedButtonGroup .roundedButtonWrapper:first-child .roundedButton {
  border-bottom-left-radius: var(--height);
  border-top-left-radius: var(--height);
}

.RoundedButtonGroup .roundedButtonWrapper:last-child .roundedButton {
  border-bottom-right-radius: var(--height);
  border-top-right-radius: var(--height);
}

.roundedButtonWrapper:hover .roundedButton {
  background-color: var(--box-background-color);
  color: var(--ui-gray-dark);
}

.roundedButtonWrapper.active .roundedButton {
  background-color: var(--active-color);
  border-color: var(--ui-border-color-active);
  color: var(--ui-gray-dark);
  z-index: 2;
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/roundedButtonGroup/RoundedButtonGroup.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,6CAA6C;EAC7C,WAAW;EACX,YAAY;EACZ,wBAAwB;MACpB,qBAAqB;UACjB,uBAAuB;EAC/B,yBAAyB;MACrB,sBAAsB;UAClB,mBAAmB;EAC3B,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;MACrB,sBAAsB;UAClB,mBAAmB;EAC3B,qCAAqC;EACrC,6CAA6C;EAC7C,kCAAkC;EAClC,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,wBAAwB;MACpB,qBAAqB;UACjB,uBAAuB;EAC/B,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,6CAA6C;EAC7C,qCAAqC;EACrC,UAAU;AACZ;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,0BAA0B;EAC1B,UAAU;AACZ","sourcesContent":[".RoundedButtonGroup {\n  --height: 25px;\n  position: relative;\n  z-index: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.RoundedButtonGroup .badgeNumber {\n  font-size: 10px;\n  font-weight: bold;\n  display: block;\n  width: 25px;\n}\n\n.RoundedButtonGroup .badgeNumber-container {\n  background-color: var(--ui-border-color-dark);\n  width: 21px;\n  height: 21px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  border-radius: 50%;\n  font-size: 12px;\n  font-weight: bold;\n  bottom: 10px;\n  left: 5px;\n  color: white;\n  position: absolute;\n}\n\n.roundedButtonWrapper {\n  width: 100%;\n  cursor: pointer;\n  display: inline-block;\n  float: left;\n  margin-left: -2px;\n  text-decoration: none;\n  text-align: center;\n}\n\n.roundedButtonWrapper.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.RoundedButtonGroup .roundedButtonWrapper .roundedButton {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: var(--ui-gray-dark);\n  border: 2px solid var(--ui-border-color-dark);\n  color: var(--text-secondary-color);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 15px;\n  font-weight: 500;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: var(--height);\n  line-height: var(--height);\n  padding: 0 16px;\n  position: relative;\n  text-transform: uppercase;\n  -webkit-transition: var(--sidebar-transition);\n  transition: var(--sidebar-transition);\n  z-index: 1;\n}\n\n.roundedButtonWrapper\n  .roundedButton\n  svg\n  .roundedButtonWrapper\n  .roundedButton\n  span {\n  margin: 0 2px;\n}\n\n.roundedButtonWrapper .roundedButton i {\n  line-height: 15px;\n  font-size: 15px;\n}\n\n.roundedButtonWrapper .bottomLabel {\n  padding: 0 10px 0 10px;\n}\n\n.bottomLabel {\n  color: var(--text-secondary-color);\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 12px;\n  margin-top: 10px;\n  margin-bottom: 2px;\n}\n\n.roundedButtonWrapper:first-child {\n  margin-left: 0;\n}\n\n.RoundedButtonGroup .roundedButtonWrapper:first-child .roundedButton {\n  border-bottom-left-radius: var(--height);\n  border-top-left-radius: var(--height);\n}\n\n.RoundedButtonGroup .roundedButtonWrapper:last-child .roundedButton {\n  border-bottom-right-radius: var(--height);\n  border-top-right-radius: var(--height);\n}\n\n.roundedButtonWrapper:hover .roundedButton {\n  background-color: var(--box-background-color);\n  color: var(--ui-gray-dark);\n}\n\n.roundedButtonWrapper.active .roundedButton {\n  background-color: var(--active-color);\n  border-color: var(--ui-border-color-active);\n  color: var(--ui-gray-dark);\n  z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
